import { OnboardMode } from "@constants";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { WindowEventQueue } from "@utils/window-event-queue";
import { EVENT_CLOSE_ONBOARDING_DIALOG, EVENT_OPEN_ONBOARDING_DIALOG } from "../constants";
import { OnboardingDialogStep } from "../constants/onboarding-steps";

export const openOBDialogEventQueue = new WindowEventQueue<OnboardingDialogOption>(EVENT_OPEN_ONBOARDING_DIALOG);

export type OnboardingDialogOption = {
  mode?: OnboardMode;
  step?: OnboardingDialogStep;
  callback?: () => void;
  layout?: _MemberSettingOnboardDialogLayout;
};

export function openOnboardingDialog(option: OnboardingDialogOption) {
  openOBDialogEventQueue.queueOrDispatch(option);
}

export function openBankAccountDialog(onUpdateSuccess?: () => void, options?: OnboardingDialogOption) {
  const dialogOption = {
    step: OnboardingDialogStep.UpdateBankAccount,
    callback: onUpdateSuccess,
    ...options,
  };
  openOBDialogEventQueue.queueOrDispatch(dialogOption);
}

export function openLegalNameDialog(onUpdateSuccess?: () => void, options?: OnboardingDialogOption) {
  const dialogOption = {
    step: OnboardingDialogStep.UpdateLegalName,
    callback: onUpdateSuccess,
    ...options,
  };
  openOBDialogEventQueue.queueOrDispatch(dialogOption);
}

export function closeOnboardingDialog() {
  window.dispatchEvent(new CustomEvent(EVENT_CLOSE_ONBOARDING_DIALOG));
}
